<div *ngIf='groupId || playerId' fxLayout='column' fxLayoutAlign='space-evenly stretch'>
  <div fxLayout='row' fxLayoutAlign='end start'>
      <i class="material-icons" (click)='close()'>
          cancel
      </i>
  </div>
  <mat-dialog-content>
  <s18-email-composer [groupId]='groupId' [playerId]='playerId' [groupEventId]='groupEventId'></s18-email-composer>
</mat-dialog-content>
</div>